var ValidationMessageProvider_1;
import { __decorate, __metadata } from "tslib";
import { injectable } from "inversify";
import { ValidationMetadataProvider } from "../metadata/ValidationMetadataProvider";
import { DEFAULT_VALIDATION_DISPLAY_MESSAGES } from "./messages";
import { compute } from "../../util/misc";
let ValidationMessageProvider = ValidationMessageProvider_1 = class ValidationMessageProvider {
    constructor() {
        this.metadataProvider = ValidationMetadataProvider.default;
    }
    static get default() {
        return this._default ??= new ValidationMessageProvider_1();
    }
    getValidationMessage(options) {
        const { target, propertyKey, ruleKey, propertyLabel, locale, fallback } = options;
        const label = propertyLabel ?? propertyKey;
        const metadata = this.metadataProvider.getValidationMetadataForTarget(target);
        const rule = metadata.properties[propertyKey]?.rules.find(x => x.name == ruleKey);
        const localizedMessage = compute(() => {
            if (rule) {
                const messageOrFactory = DEFAULT_VALIDATION_DISPLAY_MESSAGES.rules[rule.name];
                if (messageOrFactory != null) {
                    const message = typeof messageOrFactory == "function" ? messageOrFactory(rule.constraints) : messageOrFactory;
                    if (message != null) {
                        return message;
                    }
                }
            }
            return DEFAULT_VALIDATION_DISPLAY_MESSAGES.default.invalid;
        });
        let message = (localizedMessage[locale] ||
            localizedMessage[fallback] ||
            localizedMessage["en"]);
        message = message.replace("$property", `"${label}"`);
        if (rule) {
            for (let i = 0; i < rule.constraints.length; i++) {
                const constraint = rule.constraints[i];
                message = message.replace(`$constraint${i + 1}`, constraint?.toString());
            }
        }
        return message;
    }
};
ValidationMessageProvider = ValidationMessageProvider_1 = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], ValidationMessageProvider);
export { ValidationMessageProvider };
//# sourceMappingURL=ValidationMessageProvider.js.map